<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">ゴールド購入</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <p class="modal-card-body-message">購入ゴールドを選択して購入してください。</p>
        <DoronPurchaseForm :parent="parent"/>
      </section>
      <footer class="modal-card-foot"/>
    </div>
  </form>
</template>

<script>
import DoronPurchaseForm from '@/components/DoronPurchaseForm';

export default {
  name: 'DoronPurchaseModal',
  props: {
    parent: { type: Object },
  },
  components: {
    DoronPurchaseForm
  }
};
</script>

<style lang="scss">
@import '../assets/scss/modal.scss';
</style>
